module.exports = __webpack_public_path__ + "img/before.7530c430.png";